import styled, { css } from 'styled-components';
import { InputStyle, spacing } from '@pb/styles';

import { TStyledInput } from './text-input.types';

const errorStyles = css`
    border: 0.2rem solid ${({ theme }) => theme.color.red};
`;

const errorHoverFocusStyles = css`
    border: 0.2rem solid ${({ theme }) => theme.color.red};
    box-shadow: 0 0 0 0.2rem ${({ theme }) => theme.color.redTint20};
`;

export const StyledWrapper = styled.div`
    position: absolute;
    padding: 1rem;
    z-index: 1;
`;

const prependedStyles = css`
    padding-left: ${spacing(5)};
`;

export const StyledInput = styled.input<TStyledInput>`
    ${InputStyle};
    max-width: ${({ width }) => {
        switch (width) {
            case 'narrow':
                return '17.6rem';
            case 'default':
                return '29.0rem';
            case 'wide':
                return '51.8rem';
            case 'max':
            default:
                return '100%';
        }
    }};

    ${({ hasError }) => {
        if (hasError) {
            return errorStyles;
        }
    }}

    ${({ hasPrepended }) => {
        if (hasPrepended) {
            return prependedStyles;
        }
    }}
    
    background-color: ${({ theme, disabled }) =>
        disabled ? theme.color.grey3 : theme.color.white};

    &:focus {
        border: 0.1rem solid ${({ theme }) => theme.color.darkPurple};
        outline: none;
        box-shadow: 0 0 0 0.2rem ${({ theme }) => theme.color.purpleTint20};

        ${({ hasError }) => {
            if (hasError) {
                return errorHoverFocusStyles;
            }
        }}
    }

    &:disabled {
        background-color: ${({ theme }) => theme.color.grey2};
        border: 0.1rem solid ${({ theme }) => theme.color.grey5};
    }

    &[aria-invalid='true'] {
        padding: 0.4rem;
        ${({ hasPrepended }) => {
            if (hasPrepended) {
                return prependedStyles;
            }
        }}

        ${errorStyles}
        ${errorHoverFocusStyles}
    }
`;
